import { ApiError } from '@/lib/api/errors'

/*
 * P09 — what the rest of the app needs to know about a module refusal,
 * with nothing else attached (the query client imports it): the key every
 * module query sits under, and how a 403 `module_unavailable` reads.
 */

/** Every P09 workspace query — the manifest and each guide — sits under this key: invalidating it refreshes them all. */
export const MODULES_QUERY = ['modules'] as const

/** A route's module refused to this company: which one and why (a reason value, never the staff text). */
export interface ModuleRefusalInfo {
  module: string
  reason: string | null
  /** The server's words, in the language asked for. */
  message: string
}

/** A 403 `module_unavailable` (P09) — the route's module is unavailable to the company — or null for any other error. */
export function moduleRefusalOf(error: unknown): ModuleRefusalInfo | null {
  if (!(error instanceof ApiError) || error.status !== 403 || error.code !== 'module_unavailable') return null
  const payload = (typeof error.payload === 'object' && error.payload !== null ? error.payload : {}) as { module?: unknown; reason?: unknown }

  return {
    module: typeof payload.module === 'string' ? payload.module : '',
    reason: typeof payload.reason === 'string' ? payload.reason : null,
    message: error.message,
  }
}

export const isModuleRefusal = (error: unknown): boolean => moduleRefusalOf(error) !== null
